import { useMemo } from "react";
import { LIBRARY_MUSCLE_LABELS, buildMuscleStats, signed } from "../utils/muscleStats.js";
import styles from "./BiggestMovers.module.css";

const PER_SIDE = 3;

// The per-muscle deltas the six buckets are too coarse to show: which muscle
// actually gained or lost against the previous period.
export default function BiggestMovers({ muscleCounts, prevMuscleCounts }) {
  const { movers, maxAbsDelta } = useMemo(() => {
    const entries = [...buildMuscleStats(muscleCounts, prevMuscleCounts).values()];
    // Sorted descending so gainers sit above losers, matching the diverging bars.
    const sorted = entries.filter((e) => e.delta !== 0).sort((a, b) => b.delta - a.delta);
    return {
      movers: [
        ...sorted.filter((e) => e.delta > 0).slice(0, PER_SIDE),
        ...sorted.filter((e) => e.delta < 0).slice(-PER_SIDE)
      ],
      maxAbsDelta: Math.max(...entries.map((e) => Math.abs(e.delta)), 1)
    };
  }, [muscleCounts, prevMuscleCounts]);

  return (
    <div className={styles.movers}>
      <span className={styles.moversLabel}>Biggest movers</span>
      {movers.length === 0 ? (
        <span className={styles.moversEmpty}>No change vs previous period</span>
      ) : (
        <div className={styles.moverList}>
          {movers.map(({ muscle, delta }) => {
            const width = (Math.abs(delta) / maxAbsDelta) * 50;
            const up = delta > 0;
            return (
              <div key={muscle} className={styles.moverRow}>
                <span className={styles.moverName}>{LIBRARY_MUSCLE_LABELS[muscle] || muscle}</span>
                <div className={styles.moverTrack}>
                  <span className={styles.moverAxis} aria-hidden="true" />
                  <span
                    className={`${styles.moverBar} ${up ? styles.moverBarUp : styles.moverBarDown}`}
                    style={{ left: up ? "50%" : `${50 - width}%`, width: `${width}%` }}
                  />
                </div>
                <span className={`${styles.moverValue} ${up ? styles.up : styles.down}`}>
                  {signed(delta)}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
